export const changeEvent = new Event("change");

document.addEventListener("DOMContentLoaded", function () {
  const selects = document.querySelectorAll(".b-select");
  const selectOptions = document.querySelectorAll(".b-select__item");

  selects.forEach((select) => {
    const placeholderElem = select.querySelector("span");
    const placeholderText = select.dataset.placeholder;
    placeholderElem.textContent = placeholderText;

    select.addEventListener("click", function (e) {
      e.stopPropagation();

      selects.forEach((select) => {
        select.classList.remove("b-select--active");
      });

      this.classList.add("b-select--active");
    });

    select.addEventListener("change", function (e) {
      const text =
        select.querySelector(`[data-value="${select.dataset.value}"]`)
          ?.textContent || placeholderText;
      placeholderElem.textContent = text;
    });
  });

  selectOptions.forEach((option) => {
    option.addEventListener("click", function (e) {
      e.stopPropagation();

      const select = this.closest(".b-select");
      select.dataset.value = this.dataset.value;

      const placeholder = select.querySelector("span");
      placeholder.textContent = option.textContent;

      select.classList.remove("b-select--active");

      select.dispatchEvent(changeEvent);
    });
  });
});
